module.exports = __webpack_public_path__ + "static/media/MealBenefitIcon.d072c11e.svg";